/**
 * App.Layers - 图层管理（显隐/锁定）
 */

import type { LayerDef, SelectionKind } from '../types';
import { App } from './App';

/* ─────────────── Module: Layers（图层树：显隐 / 锁定）─────────────── */
App.Layers = {
  /** 图层定义 */
  defs: [
    { id: 'grid', name: '网格 / 地板', visible: true, locked: false, group: 'gGrid', kind: null },
    { id: 'walk', name: '可走管空间', visible: true, locked: false, group: 'gWalk', kind: null },
    { id: 'forbid', name: '禁行区', visible: true, locked: false, group: 'gForbid', kind: null },
    { id: 'room', name: '设备机房', visible: true, locked: false, group: 'gRoom', kind: 'room' as SelectionKind },
    { id: 'end', name: '末端', visible: true, locked: false, group: 'gEnd', kind: 'end' as SelectionKind },
    { id: 'mark', name: '名称标签', visible: true, locked: false, group: 'gMark', kind: null },
    { id: 'junction', name: '走管交接点', visible: true, locked: false, group: 'gJunction', kind: null },
    { id: 'path', name: '连接路径', visible: true, locked: false, group: 'gPath', kind: null },
    { id: 'search', name: '搜索过程', visible: false, locked: false, group: 'gSearch', kind: null },
    { id: 'riser', name: '立管', visible: true, locked: false, group: 'gRiser', kind: 'riser' as SelectionKind },
    { id: 'sel', name: '选中高亮', visible: true, locked: false, group: 'gSel', kind: null },
  ] as LayerDef[],

  /**
   * 应用图层配置到渲染器
   */
  apply(): void {
    for (const d of this.defs) {
      const g = (App.Render as any)[d.group];
      if (g) g.visible = d.visible;
      if (d.id === 'riser' && (App.Render as any).gRiserTile) {
        (App.Render as any).gRiserTile.visible = d.visible;
      }
    }
  },

  /**
   * 设置图层可见性
   */
  setVisibility(id: string, vis: boolean): void {
    const d = this.defs.find(x => x.id === id);
    if (!d) return;
    d.visible = vis;
    const g = (App.Render as any)[d.group];
    if (g) g.visible = vis;
    if (id === 'riser' && (App.Render as any).gRiserTile) {
      (App.Render as any).gRiserTile.visible = vis;
    }
  },

  /**
   * 设置图层锁定状态
   */
  setLocked(id: string, lk: boolean): void {
    const d = this.defs.find(x => x.id === id);
    if (!d) return;
    d.locked = lk;
  },

  /**
   * 判断某种类型的对象是否被锁定
   */
  isKindLocked(kind: SelectionKind | null): boolean {
    if (!kind) return false;
    const d = this.defs.find(x => x.kind === kind);
    return d ? d.locked : false;
  },

  /**
   * 渲染图层控制面板
   */
  render(): void {
    const wrap = document.getElementById('layersWrap');
    if (!wrap) return;

    let html = '';
    for (const d of this.defs) {
      const v = d.visible ? 'checked' : '';
      const l = d.locked ? 'checked' : '';
      html += `<div class="layer-row">
        <label class="leye">
          <input type="checkbox" data-lid="${d.id}" data-act="vis" ${v}> ${d.name}
        </label>
        <label class="llock" title="锁定后该类对象不可编辑">
          <input type="checkbox" data-lid="${d.id}" data-act="lock" ${l}> 🔒
        </label>
      </div>`;
    }
    wrap.innerHTML = html;

    const self = this;
    wrap.querySelectorAll('input').forEach((cb: Element) => {
      const checkbox = cb as HTMLInputElement;
      checkbox.onchange = () => {
        const d = self.defs.find(x => x.id === checkbox.dataset.lid);
        if (!d) return;
        if (checkbox.dataset.act === 'vis') {
          self.setVisibility(d.id, checkbox.checked);
        } else {
          self.setLocked(d.id, checkbox.checked);
        }
      };
    });
  },
};

export default App.Layers;
export const Layers = App.Layers;
